import Quasar from 'quasar/src/vue-plugin.js';import Dark from 'quasar/src/plugins/dark/Dark.js';

export default function () {
  let lastSearchQuery = {}
  // Lets Brand/Presentation/Smpc breadcrumbs show "arrived from a tracked
  // list" (Favourites group / Watchlist results) instead of always the static
  // Brands parent — captured only while actually on FavouriteGroup/WatchlistResults,
  // same idiom as lastSearchQuery above.
  let returnContext = null // { name: 'FavouriteGroup' | 'WatchlistResults', params, labels }
  const RETURN_LIST_ROUTE = new Set(['FavouriteGroup', 'WatchlistResults'])
  const BRAND_SUBTREE = new Set(['Brand', 'Presentation', 'Smpc'])

  return {
    setDark: async function (val) {
      Dark.set(val)
      this.dark = val
    },

    // Set Quasar's components language
    setQlang: async function (val) {
      const qLangs = import.meta.glob('../../../node_modules/quasar/lang/*.mjs')
      let qLang
      try {
        qLang = await qLangs[`../../../node_modules/quasar/lang/${val}.mjs`]()
      } catch (err) {
        qLang = await qLangs['../../../node_modules/quasar/lang/en-US.mjs']()
        console.error('Language not found on the list of Quasar\'s languages. Defaulting to American English (en-US)')
      }
      Quasar.lang.set(qLang.default)
    },

    setLang: async function (val) {
      if (val !== this.lang) {
        this.setQlang(val)
        this.i18next.changeLanguage(val, () => (this.i18next.locale = val))
        this.lang = val
      }
    },

    buildBreadcrumbs: function (route, labels = {}) {
      const map = Object.fromEntries(this.router.getRoutes().map(r => [r.name, r]))
      const params = route.params ?? {}

      const getChain = cur => cur ? (cur.meta?.parent ? [cur, ...getChain(map[cur.meta.parent])] : [cur]) : []
      let chain = getChain(route).reverse()
      // console.log('%cbuildBreadcrumbs', 'color:lime', chain)

      const searchRoute = chain.find(r => r.name === 'Brands')
      if (searchRoute?.query !== undefined) lastSearchQuery = searchRoute.query

      // Capture the "tracked list" we're viewing from (only while actually on
      // it), or drop it once we've navigated somewhere unrelated to it —
      // otherwise a brand reached later via plain search would inherit a
      // stale Favourites/Watchlist breadcrumb prefix.
      if (RETURN_LIST_ROUTE.has(route.name)) {
        // Captures the WHOLE labels dict, not just this route's own label —
        // the spliced-in chain can be several nodes deep (e.g. Watchlists,
        // Watchlist, WatchlistResults), and an ancestor like Watchlist needs
        // its own label (the watchlist's title) too, not just the leaf's.
        returnContext = { name: route.name, params, labels: { ...labels } }
      } else if (!BRAND_SUBTREE.has(route.name)) {
        returnContext = null
      }

      // On Brand/Presentation/Smpc, swap the static Brands ancestor for the
      // full ancestor chain of the tracked list we actually arrived from, if
      // any (e.g. Watchlists > {watchlist} > Results, not just one node).
      const effectiveLabels = { ...labels }
      let paramsFor = () => params
      if (returnContext && BRAND_SUBTREE.has(route.name)) {
        const brandsIndex = chain.findIndex(r => r.name === 'Brands')
        const itemRoute = map[returnContext.name]
        const returnChain = itemRoute ? getChain(itemRoute).reverse() : []
        if (brandsIndex !== -1 && returnChain.length) {
          chain = [...chain.slice(0, brandsIndex), ...returnChain, ...chain.slice(brandsIndex + 1)]
          Object.assign(effectiveLabels, returnContext.labels)
          const returnParams = returnContext.params
          // Every node in the spliced-in chain (e.g. Watchlists, Watchlist,
          // WatchlistResults) needs the CAPTURED params (:watchlistId), not
          // the current route's own params (e.g. Brand's :brandId) — not
          // just the leaf, since the chain can be more than 2 nodes deep.
          const returnChainNames = new Set(returnChain.map(r => r.name))
          paramsFor = name => (returnChainNames.has(name) ? returnParams : params)
        }
      }

      this.breadcrumbs = chain.map(({ name, meta }) => ({
        name,
        labelKey: !meta?.parent ? `${meta?.namespace}:Page.title` : null,
        label: effectiveLabels[name] ?? null,
        depth: meta?.depth,
        icon: meta?.icon,
        namespace: meta?.namespace,
        to: {
          name,
          params: Object.fromEntries(
            Object.entries(paramsFor(name)).filter(([key]) => (map[name]?.path ?? '').includes(`:${key}`))
          ),
          ...(name === 'Brands' ? { query: lastSearchQuery } : {})
        }
      }))
    }

    // notify: function (params) {
    //   this.$toast(params)
    // }
  }
}
